const system = {
  title: 'Hauler Hero',
  name: 'Hauler Hero',
  version: '',
  website: '',
  supportEmail: '',
}

export default system
